export type ParsedHealthDateTime = {
  iso: string;
  localDate: string;
  timezoneOffset: string;
  epochMs: number;
};

const DATE_RE = /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2}) ([+-]\d{4})$/;

function pad2(value: number): string {
  return String(value).padStart(2, "0");
}

export function parseAppleHealthDate(value: string): ParsedHealthDateTime | null {
  const trimmed = value.trim();
  const match = DATE_RE.exec(trimmed);
  if (!match) {
    const parsed = Date.parse(trimmed);
    if (Number.isNaN(parsed)) {
      return null;
    }
    const date = new Date(parsed);
    const localDate = `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;
    return {
      iso: date.toISOString(),
      localDate,
      timezoneOffset: "+0000",
      epochMs: parsed
    };
  }

  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const hour = Number(match[4]);
  const minute = Number(match[5]);
  const second = Number(match[6]);
  const offset = match[7];

  const sign = offset.startsWith("-") ? -1 : 1;
  const offsetHours = Number(offset.slice(1, 3));
  const offsetMinutes = Number(offset.slice(3, 5));
  const totalOffsetMinutes = sign * (offsetHours * 60 + offsetMinutes);

  const utcMs = Date.UTC(year, month - 1, day, hour, minute, second) - totalOffsetMinutes * 60 * 1000;

  return {
    iso: new Date(utcMs).toISOString(),
    localDate: `${match[1]}-${match[2]}-${match[3]}`,
    timezoneOffset: offset,
    epochMs: utcMs
  };
}

export function minutesBetween(startMs: number, endMs: number): number {
  return Math.max(0, Math.round((endMs - startMs) / 60000));
}

export function todayDateKey(): string {
  const now = new Date();
  return `${now.getFullYear()}-${pad2(now.getMonth() + 1)}-${pad2(now.getDate())}`;
}
